import logger from '../logger';
/**
 * Voluntarily release an active booking hold (e.g. leaving Review back to Time).
 * Deletes the hold via API and stops the timer. Retains UUID unless expired.
 */

import { useCallback } from 'react';
import { useBookingSession } from '../../Context/BookingSession/BookingSessionContext';
import { useBookingTimer } from '../../Context/Timer/useBookingTimer';
import { clearHoldSessionKeys, releaseBookingHoldOnce } from '../bookingHold';
import { getSessionStorageValue, STORAGE_KEYS } from '../SessionStorage';

export const useReleaseBookingHold = () => {
  const { setBookingID, uuid, setUuid } = useBookingSession();
  const { resetTimer } = useBookingTimer();

  const releaseHold = useCallback(async ({ expired = false } = {}) => {
    const holdUuid = uuid || getSessionStorageValue(STORAGE_KEYS.BOOKING_UUID);
    const bookingId = getSessionStorageValue(STORAGE_KEYS.BOOKING_ID);
    // Expiry invalidates the UUID immediately, even if deletion is slow or fails.
    if (expired) setUuid(null);
    if (holdUuid && bookingId) {
      try {
        await releaseBookingHoldOnce(holdUuid);
      } catch (error) {
        logger.error('Error releasing booking hold:', error);
      }
    }

    clearHoldSessionKeys({ expired });
    setBookingID(null);
    resetTimer();
  }, [uuid, setBookingID, setUuid, resetTimer]);

  return { releaseHold };
};

export default useReleaseBookingHold;
